import Reveal from "../../components/ui/Reveal";
import styles from './page.module.css'

function Card({ title }) {
    return <div className="item">
        <div className={styles.itemDot} />
        <div>
            <h3 className={styles.itemTitle}>{title}</h3>
        </div>
    </div>
}

function Card2({ title, desc }) {
    return <div className="item">
        <div className={styles.itemDot} />
        <div>
            <h3 className={styles.itemTitle}>{title}</h3>
            <p className={styles.itemDesc}>{desc}</p>
        </div>
    </div>
}
function GroupHeader({ title, intro }) {
    return <div className={styles.groupHead}>
        {/* <span className={styles.groupIcon}>{group.icon}</span> */}
        <div>
            <h2 className={styles.sectiontitle}>{title}</h2>
            <p className={styles.sectionIntro}>{intro}</p>
        </div>
    </div>
}

export default function Opportunity() {
    const list1 = [
        "Population Growth",
        "Urbanization",
        "Increased Healthcare investments",
        "Expansion of Private Healthcare Facilities",
        "Government Healthcare Modernization Programs",
        "Growing Demand for Advanced Diagnostics"

    ]
    const list2 = [
        {
            title: "Dignostic Imaging",
            desc: "Growing demand for MRI, CT Scan, X-Ray, Mammography and Ultrasound systems"
        },
        {
            title: "Oncology & Cancer care",
            desc: "Expansion of cancer treatment facilities requiring advanced radiation therapy and nuclear medicine technologies."
        },
        {
            title: "Hospital Infrastructure",
            desc: "Increased investment in medical gas systems, modular operating rooms, oxygen plants, and critical care facilities."
        },
        {
            title: "Specialized Healthcare centers",
            desc: "Growing need for cardiology, pathology, surgical and laboratory solutions. Infinity is strategically positioned to support this transformation through its established regional presence and extensive project experience."
        }
    ]
    const list3 = [
        {
            title: "Monetizing Technical Services",
            desc: "Transforming maintenance and engineering services into a predictable, high-margin, recurring revenue generator."
        },
        {
            title: "Digital Health Integration",
            desc: "Introducing smart, cloud-connected medical devices and digital diagnostic platforms to future-proof regional healthcare networks."
        },
        {
            title: "Institutional Compliance",
            desc: "Operating under rigorous international compliance and corporate governance standards, mitigating risks for global financial stakeholders."
        }
    ]





    return (
        <main>
            <section className="pageHero">
                <div className="container" style={{ position: "relative", zIndex: 1 }}>
                    <Reveal>
                        <span className="pageHeroLabel">Market Opportunity</span>
                        <h1 className="pageHeroTitle">Positioned in One of Africa&apos;s fastest-growing healthcare markets</h1>

                    </Reveal>
                </div>
            </section>
            <section className={styles.content}>
                <div>
                    <div className={styles.groupHead}>
                        {/* <span className={styles.groupIcon}>{group.icon}</span> */}
                        <div>
                            <h2 className={styles.sectiontitle}>{"Demand"}</h2>
                            <p className={styles.sectionIntro}>{"The demand for specialized, high-tier diagnostic imaging, oncology, and cardiology solutions in East Africa is experiencing unprecedented growth due to:"}</p>
                        </div>
                    </div>
                    <div className={styles.itemsGrid}>
                        {
                            list1.map((e, idx) => {
                                return <Card title={e} key={idx} />
                            })
                        }
                    </div>
                </div>
                <div>
                    <GroupHeader
                        title="Investment in HealthCare Infrastructure"
                        intro="Ethiopia and Kenya are investing heavily in healthcare infrastructure, creating significant opportunities in:"
                    />
                    <div className={styles.itemsGrid}>
                        {
                            list2.map((e, idx) => {
                                return <Card2 title={e.title} desc={e.desc} key={idx} />
                            })
                        }
                    </div>
                </div>

                <div>
                    <GroupHeader title="Core Investment Anchors" intro="" />
                    <div className={styles.itemsGrid}>
                        {
                            list3.map((e, idx) => {
                                return <Card2 title={e.title} desc={e.desc} key={idx} />
                            })
                        }
                    </div>
                </div>
            </section>
        </main>
    )
}